const optimizationGoals = [
  {
    name: '',
    label: 'Select an adset optimization/performance goal',
  },
  {
    name: 'AD_RECALL_LIFT',
    label: 'Ad recall lift',
  },
  {
    name: 'APP_INSTALLS',
    label: 'App installs',
  },
  {
    name: 'CLICKS',
    label: 'Clicks',
  },
  {
    name: 'CONVERSATIONS',
    label: 'Conversations',
  },
  {
    name: 'ENGAGED_USERS',
    label: 'Engaged users',
  },
  {
    name: 'EVENT_RESPONSES',
    label: 'Event responses',
  },
  {
    name: 'IMPRESSIONS',
    label: 'Impressions',
  },
  {
    name: 'LEAD_GENERATION',
    label: 'Lead generation',
  },
  {
    name: 'LINK_CLICKS',
    label: 'Link clicks',
  },
  {
    name: 'OFFSITE_CONVERSIONS',
    label: 'Offsite conversions',
  },
  {
    name: 'PAGE_ENGAGEMENT',
    label: 'Page engagement',
  },
  {
    name: 'PAGE_LIKES',
    label: 'Page likes',
  },
  {
    name: 'POST_ENGAGEMENT',
    label: 'Post engagement',
  },
  {
    name: 'REACH',
    label: 'Reach',
  },
  {
    name: 'LANDING_PAGE_VIEWS',
    label: 'Landing Page Views',
  },
  {
    name: 'THRUPLAY',
    label: 'Thruplay',
  },
  {
    name: 'VISIT_INSTAGRAM_PROFILE',
    label: 'Visit instagram profile',
  },
];

export default optimizationGoals;
